import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MembershipsPage } from '../../modules/Memberships/main';
import {
  DUE_WINDOWS,
  ORDER_TABS,
  PAGE_VIEWS,
  PM_SCHEDULE_SORT_KEYS,
  PM_SECTIONS,
  PM_SORT_KEYS,
  PM_WINDOWS,
} from '../../modules/Memberships/pm-schedule/types';
import { STATUS_TABS, TYPE_FILTERS } from '../../modules/Memberships/types';

const membershipsSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
  type: z.enum(TYPE_FILTERS).catch('all'),
  payment_method: z.string().catch('all'),
  tab: z.enum(STATUS_TABS).catch('all'),
  renewals_due: z.boolean().catch(false),
  added_plans: z.boolean().catch(false),
  view: z.enum(PAGE_VIEWS).catch('contracts'),
  pm: z.enum(PM_SECTIONS).catch('queue'),
  pm_q: z.string().optional().catch(undefined),
  pm_due: z.enum(DUE_WINDOWS).catch('all'),
  pm_csr: z.number().int().catch(0),
  pm_unassigned: z.boolean().catch(false),
  pm_sector: z.enum(['all', 'residential', 'commercial']).catch('all'),
  pm_dept: z.number().int().catch(0),
  pm_sort: z.enum(PM_SORT_KEYS).optional().catch(undefined),
  pm_dir: z.enum(['asc', 'desc']).optional().catch(undefined),
  pm_group: z.boolean().catch(false),
  pm_status: z.string().catch('all'),
  pm_window: z.enum(PM_WINDOWS).catch('plan_year'),
  pm_vrm: z.boolean().catch(false),
  pm_fs_sort: z.enum(PM_SCHEDULE_SORT_KEYS).optional().catch(undefined),
  pm_fs_dir: z.enum(['asc', 'desc']).optional().catch(undefined),
  orders_tab: z.enum(ORDER_TABS).catch('all'),
  orders_q: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/memberships/')({
  component: MembershipsPage,
  validateSearch: membershipsSearchSchema,
  head: () => ({
    meta: [{ title: 'Memberships' }],
  }),
});
